
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import {
	SoftwareType,
	SchemaDic,
	SchemaData,
	TableSchema,
	ExtractorSchema,
} from '@/store/models.def';
import ExtractorSchemaComponent from './ExtractorSchema.vue';
import uuid from 'uuid';

@Component({
	components: {
		ExtractorSchemaComponent,
	},
})
export default class TableSchemaComponent extends Vue {
	@Prop({
		default: {
			id: uuid.v4(),
			table: '',
			collection: '',
			keyField: '',
			type: 'master',
			masterKey: '',
			detailPath: '',
			extractor: {},
		},
	})
	public value!: TableSchema;

	@Prop({ default: null }) public parentId!: string;

	public showExtractor = false;

	public data: TableSchema = {
		id: uuid.v4(),
		table: '',
		collection: '',
		keyField: '',
		type: this.parentId ? 'inherit' : 'master',
		masterKey: '',
		detailPath: '',
		extractor: {},
	};

	public get types(): Array<'master' | 'detail' | 'remove' | 'inherit'> {
		const response: Array<'master' | 'detail' | 'remove' | 'inherit'> = [
			'master',
			'detail',
		];
		if (this.parentId) {
			response.push('remove', 'inherit');
		}
		return response;
	}

	public validateType(): boolean {
		if (this.parentId) {
			return ['master', 'detail', 'remove', 'inherit'].includes(this.data.type);
		}
		return ['master', 'detail'].includes(this.data.type);
	}

	public validateInheritable(str: string): boolean {
		if (typeof str !== 'string') {
			return false;
		}
		if (str === '' && !this.parentId) {
			return false;
		}
		return true;
	}
	public validateDetailProp(str?: string): boolean {
		if (!str && !this.parentId && this.data.type === 'detail') {
			return false;
		}
		return true;
	}

	@Watch('value')
	public onValueChanged(val: TableSchema, oldVal: TableSchema) {
		if (val !== null) {
			this.data = val;
			const result = this._validfy();
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public mounted() {
		let result = null;
		if (this.value) {
			this.data = this.value;
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}
	protected _onTableBlur() {
		this.data.table = this.data.table.toUpperCase();
		this.$emit('input', this._validfy());
	}
	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		if (
			!this.data.id ||
			!this.data.table ||
			!this.data.collection ||
			!this.validateInheritable(this.data.keyField) ||
			!this.validateType() ||
			!this.validateDetailProp(this.data.masterKey) ||
			!this.validateDetailProp(this.data.detailPath) ||
			!this.data.extractor
		) {
			return null;
		}
		return this.data;
	}
}
